<!--
 * @Descripttion:
 * @Author: kongweiqiang
 * @Date: 2021-08-31 15:49:51
 * @LastEditors: kongweiqiang
 * @LastEditTime: 2021-09-07 14:57:27
-->
<template>
  <el-dialog title="考试详情" close="dia" :visible.sync="dialogVisible" width="1000px" append-to-body :close-on-click-modal='false' :close-on-press-escape='false' >
    <div style="max-height:560px;overflow:auto;" ref="diabody">
      <div class="tab-con" v-loading='dataListLoading'>

        <div class="tab-con-que">
          <!-- 单选题 activeName==1-->
          <div class="tab-con-queLib" v-for="(item,index) in dataList" :key="index">
            <div class="tab-con-queLib-ti">
             {{item._index}}. {{item.name}}&emsp;&emsp;
             <!-- <span :style="item.questionType!='3'?'color:red;':item.answer=='T'?'color:green;':'color:red;'">{{item.questionType!=3?item.answer:item.answer=='T'?'正确':'错误'}}</span> -->
             （<span v-if="item.questionType!='3'" :style="item.is_true=='0'?'color:red;':'color:green;'">{{item.answer}}</span>
             <span v-else :style="item.is_true=='0'?'color:red;':'color:green;'">{{item.answer==''?'':item.answer=='T'?'正确':'错误'}}</span>）
            </div>
            <div v-if="item.is_true=='0'">回答错误，正确答案：<span style="color:green;font-weight:bold;">{{item.questionType!='3'?item.rightAnswer:item.rightAnswer=='T'?'正确':'错误'}}</span></div>
            <!-- <div v-else>回答正确！</div> -->
            <!-- 多选题 activeName==2-->
            <div class="tab-con-queLib-answer" v-if="item.questionType!='3'">

              <div v-for="(itemB,indexB) in item.contentMap" :key="indexB">{{itemB.name}}.{{itemB.value}}</div>
              <!-- <div>B.{{item.contentB}}</div>
              <div>C.{{item.contentC}}</div>
              <div>D.{{item.contentD}}</div> -->
            </div>
          </div>
        </div>
      </div>

    </div>
     <div class="page" slot="footer">
        <el-pagination :current-page="page" :page-size="limit" :total="total" layout="total, prev, pager, next, jumper" @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
       <!-- <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">支付</el-button>
  </span> -->
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      dataListLoading: false,
      id: '',
      page: 1,
      limit: 10,
      total: 0
    }
  },
  methods: {
    init (id) {
      this.dialogVisible = true
      this.id = id
      this.getList()
    },
    pageCurrentChangeHandle (val) {
      this.page = val
      this.$refs.diabody.scrollTo(0, 0)
      this.getList()
    },
    getList () {
      this.dataListLoading = true
      this.$get(`client/exam/userExamQuestionsInfo`, {
        page: this.page,
        limit: 10,
        id: this.id
      })
        .then((res) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            this.dataList = []
            this.total = 0
            return false
          }
          this.dataList = res.data.dataList
          this.dataList.forEach((item, index) => {
            item._index =
              this.page - 1 === 0
                ? index + 1
                : index + 1 < this.limit
                  ? (this.page - 1) * this.limit + (index + 1)
                  : this.page * this.limit
          })
          this.total = res.data.total
        })
        .catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.bank-type /deep/.el-radio__label img {
  height: 24px;
  position: absolute;
  top: 7px;
}
.bank-type /deep/.el-radio__label .name {
  padding-left: 30px;
}
.dia /deep/ .el-dialog__body{
  max-height: 560px;
}
.page {
  text-align: center;
  margin: 20 auto;
}
.tab-con {
  padding: 10px 0;
  background: white;
  margin-bottom: 20px;
  &-ti {
    border-left: 4px solid #2977ee;
    text-indent: 10px;
    font-size: 18px;
  }
  &-que {
    padding: 5px 20px;
  }
  &-queLib {
    &-ti {
      font-size: 15px;
      padding: 10px 0;
      color: #4A4A4A;
      letter-spacing: 1px;
      font-weight: bold;
    }
    &-answer{
      padding: 10px 0;
      div{
        line-height: 30px;
        font-size: 13px;
        color: #333333;
      }
    }
  }
}
</style>
